import type { PitchSource } from "./contract";

export interface AssumptionPresentation {
  assumedHeights?: boolean;
  pitchSources: PitchSource[];
}

export function assumptionLabel(input: AssumptionPresentation): string | null {
  const assumedPitch = input.pitchSources.includes("assumed");
  if (input.assumedHeights && assumedPitch) {
    return "Roof height and pitch are indicative for this preview.";
  }
  if (input.assumedHeights) return "Roof height is indicative for this preview.";
  if (assumedPitch) return "Roof pitch is indicative for this preview.";
  return null;
}
